<template>
  <header
    v-if="!_isMobile()"
    class="headerHomePc"
    :class="[menuFixed ? 'headerHomePcActive' : '']"
  >
    <div class="headerHomePcContent">
      <a-row type="flex">
        <a-col flex="237px" class="displayCenter">
          <img
            :src="logo ? logo : '../assets/aice2/aice_logo_new.png'"
            style="width: 147px; height: 24px"
            alt=""
          />
        </a-col>
        <a-col flex="auto">
          <div
            :class="['menu-bar', showMenu ? 'show' : 'hide']"
            @mouseleave="leave"
            @mouseover="over"
          >
            <t-menu class="menu" mode="horizontal" :menu="menus"></t-menu>
          </div>
        </a-col>
        <a-col flex="130px">
          <div
            class="displayCenter"
            style="height: 100%"
            v-if="$store.state.user.info"
          >
            <img
              class="avatar"
              :src="avatarUrl"
              @error="setDefaultImage"
              @click="toCenter"
              alt=""
            />
            <a-dropdown>
              <div style="cursor: pointer">
                <span style="padding: 0 13px 0 8px">{{
                  $store.state.user.info.realname
                }}</span>
                <a-icon type="caret-down" />
              </div>
              <a-menu slot="overlay">
                <a-menu-item @click="handleLogout"> 退出 </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
          <div
            v-else
            class="displayCenter"
            style="height: 100%; cursor: pointer"
          >
            <span @click="toLogin">登录</span>
            <a-divider type="vertical" />
            <span @click="toRegister">注册</span>
          </div>
        </a-col>
      </a-row>
    </div>
  </header>
  <header
    v-else
    class="displayCenterBetween mobileHeader"
    :class="[menuFixed ? 'headerHomePcActive' : '']"
  >
    <a-dropdown :trigger="['click']">
      <div class="menuMobile">导航<br />菜单</div>
      <a-menu slot="overlay">
        <menu-item :items="menus" @menu-item-click="openMenuFn" />
      </a-menu>
    </a-dropdown>

    <div>
      <div
        class="displayCenter"
        style="height: 100%"
        v-if="$store.state.user.info"
      >
        <img
          class="avatar"
          :src="avatarUrl"
          @error="setDefaultImage"
          @click="toCenter"
          alt=""
        />
        <a-dropdown>
          <div style="cursor: pointer">
            <span style="padding: 0 13px 0 8px">{{
              $store.state.user.info.realname
            }}</span>
            <a-icon type="caret-down" />
          </div>
          <a-menu slot="overlay">
            <a-menu-item @click="handleLogout"> 退出 </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <div v-else class="displayCenter" style="height: 100%; cursor: pointer">
        <span @click="toLogin">登录</span>
        <a-divider type="vertical" />
        <span @click="toRegister">注册</span>
      </div>
    </div>
  </header>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import config from "../theme.config";
import { mapActions } from "vuex";
import { mixinDevice } from "@/utils/mixin.js";
import TMenu from "@/components/menu";
import { jumpMixins } from "@/utils/jumpMixins";
import { getQiniuUrl, getQiniuFile } from "@/utils/qiniu.js";
import defaultImage from "../assets/avatar2.png";
const MenuItem = {
  name: "MenuItem",
  props: ["items"],
  methods: {
    handleClick(item) {
      this.$emit("menu-item-click", item);
    },
  },
  render(h) {
    return h(
      "a-menu",
      { class: "aice-a-menu" },
      this.items.map((item) => {
        if (item.children && item.children.length) {
          return h("a-sub-menu", { key: item.id, class: "aice-a-sub-menu" }, [
            h("template", { slot: "title" }, item.title),
            ...item.children.map((child) =>
              h(MenuItem, {
                props: { items: [child] },
                on: { "menu-item-click": this.handleClick },
              })
            ),
          ]);
        } else {
          return h(
            "a-menu-item",
            {
              key: item.id,
              class: "aice-a-menu-item",
              on: { click: () => this.handleClick(item) },
            },
            item.title
          );
        }
      })
    );
  },
};
export default {
  name: "Header",
  mixins: [mixinDevice, jumpMixins],
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TMenu,
    MenuItem,
  },
  data() {
    return {
      showLogin: false,
      showRegister: false,
      showMenu: true,
      logo: "",
      token: "",
      cycssToken: "",
      menus: [],
      menuFixed: false,
    };
  },
  created() {
    this.token = Vue.ls.get(ACCESS_TOKEN);
    this.cycssToken = Vue.ls.get("cysccToken");
    let tenantInfo = this.$store.getters.tenantInfo;
    let hostNameList = ["e.aice.org.cn", "ybc.aice.org.cn", "192.168.1.162"];
    if (hostNameList.indexOf(window.location.hostname) != -1) {
      this.logo = tenantInfo.logo2;
    } else {
      this.logo = tenantInfo.logo;
    }
    this.menus = this.$store.getters.menuList;
  },
  computed: {
    avatarUrl() {
      if (this.$store.state.user.info && this.$store.state.user.info.avatar) {
        if (this.$store.state.user.info.thirdType == "cyscc") {
          return (
            "https://cast-files.oss-cn-beijing.aliyuncs.com/" +
            this.$store.state.user.info.avatar
          );
        } else {
          return this.getQiniuUrl(this.$store.state.user.info.avatar);
        }
      } else {
        return require("../assets/avatar2.png");
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    ...mapActions(["Logout"]),
    setDefaultImage(e) {
      e.target.src = defaultImage;
    },
    onSearch(v) {
      console.log(v);
    },
    leave() {
      if (this.autoHide) this.showMenu = false;
    },
    over() {
      if (this.autoHide) this.showMenu = true;
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop >= 105) {
        this.menuFixed = true;
      } else {
        this.menuFixed = false;
      }
    },
    loginSuccess() {
      this.showLogin = false;
      this.userInfo = this.$store.state.user.info;
    },
    regSuccess() {
      this.showRegister = false;
      this.showLogin = true;
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              Vue.ls.remove("cysccToken");
              window.location.reload();
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
    openMenuFn(item) {
      if (item.url) {
        this.$router.push({ path: item.url });
      }
    },
  },
};
</script>
<style>
.ant-menu-vertical.ant-menu-sub,
.ant-menu-vertical-left.ant-menu-sub,
.ant-menu-vertical-right.ant-menu-sub {
  min-width: auto !important;
}
.ant-menu-submenu-vertical > .ant-menu-submenu-title .ant-menu-submenu-arrow {
  right: 0 !important;
}
.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 30px !important;
  line-height: 30px !important;
}
.ant-menu-vertical > .ant-menu-item {
  height: 30px !important;
  line-height: 30px !important;
}
.ant-menu-item-selected {
  background: #f4f4f5 !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  color: #323335 !important;
  background-image: url(../assets/aice2/menu_active.png) !important;
  background-size: 30% 5px !important;
  background-position: 50% 75% !important;
  background-repeat: no-repeat !important;
}
.ant-menu-item-selected > a {
  color: #333 !important;
}
.ant-menu-item-active {
  background: #f4f4f5 !important;
}
.ant-menu-item-active a {
  color: #333 !important;
}
</style>
<style lang="less" scoped>
/deep/.ant-menu-submenu-arrow {
  right: 0 !important;
}
/deep/.aice-a-menu-item,
.aice-a-sub-menu {
  height: 30px !important;
  line-height: 30px !important;
}
.mobileHeader {
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;
  height: 44px;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 99;

  .menuMobile {
    font-weight: 600;
    font-size: 12px;
    color: #2a55e5;
    line-height: 20px;
  }
  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }
}
.headerHomePcActive {
  background: #fff !important;
}
.headerHomePc {
  width: 100%;
  height: 64px;
  background: #f2f6f8;
  position: sticky;
  left: 0;
  top: 0;
  z-index: 9;
  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
  }
  .headerHomePcContent {
    width: 1440px;
    height: 100%;
    margin: 0 auto;
  }
}
.hide {
  height: 50px;
  background-color: transparent !important;
  // transition: all 0.1s ease;
}

.menu-bar {
  width: 100%;
  height: 100%;
  z-index: 999;
  .menu {
    background: transparent;
    max-width: 1200px;
    height: 100%;
    margin: auto;
    /deep/.ant-menu-item,
    /deep/.ant-menu-submenu {
      // background: rgb(37,106,243);
      // border-radius: 10px;
      border-bottom: none;
      line-height: 64px;
      padding: 0 8px;
      .anticon {
        display: none;
      }
      .ant-menu-submenu-title {
        padding: 0 8px;
      }
      a {
        display: block;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        padding: 2px 12px;
        font-family: "微软雅黑 Bold", "微软雅黑 Regular", "微软雅黑", sans-serif;
        font-size: 14px;
        color: #323335;
      }
    }

    /deep/.ant-menu-submenu-active,
    /deep/.ant-menu-item-active {
      border-bottom: none;
      font-weight: 700;
      a {
        font-weight: 600;
        font-size: 14px;
        color: #323335;
        //text-decoration: underline;
        background-image: url(../assets/aice2/menu_active.png);
        background-size: 30% 5px;
        background-position: 50% 75%;
      }
    }
  }
  /deep/.ant-menu-submenu-selected{
        font-weight: 600;
        font-size: 14px;
        color: #323335;
        background-image: url(../assets/aice2/menu_active.png);
        background-size: 30% 5px;
        background-position: 50% 75%;
        background-repeat: no-repeat;
  }
  .ant-menu-horizontal {
    border-bottom: none;
  }
}

.mobile {
  .logo {
    margin-top: 5px;
    margin-left: 15px;
  }
  .login-btn-wrap {
    margin-right: 20px !important;
  }
  .ant-menu-item {
    padding: 0 8px;
  }
  .ant-menu-item > a {
    font-size: 12px !important;
  }
  .menu {
    padding: 0px 15px;
  }
}
</style>